module.exports = __webpack_public_path__ + "static/media/medical_retraumatization.51862001.webp";